<template>
        <div v-if="variables.length>0" class="form-group row">
                <label for="staticEmail" class="col-sm-3 col-md-3 col-lg-3 col-form-label"> Seleccione las variables a ver: </label>
           <div class="col-sm-9 col-md-9 col-ls-9">
                <div v-if="!particularMaterial" id= "variables">
                   <div class='form-check' v-for="(item,i) in variables" :key="i">
                        <input class='form-check-input'
                         type='checkbox'
                         :id='item'
                         :value="item"
                         v-model='checked_variables'
                         @change="emitVariablesSelected(), Change_Variables(checked_variables),
                                Check_Form(), Change_Mode('automatic')"
                         autocomplete="off"
                        >
                        <label class='form-check-label' v-html="labels[i]" :for="item"></label>
                   </div>
                </div>

                <div v-if="isGases">
                        <label class="form-check-label-radio">
                                <input class='form-check-input-radio'
                                type='radio'
                                :value="gasesVariables"
                                v-model='checked_variables'
                                @change="emitVariablesSelected(), Change_Variables(checked_variables),
                                Check_Form(), Change_Mode('automatic')"
                                name="inputAirQuality">
                                Gases
                        </label>
                </div>
                <div v-if="particularMaterial" id="airQuality">
                        <label class='form-check-label-radio'>
                                <input class='form-check-input-radio'
                                type='radio'
                                value= 'particularMaterialManual'
                                v-model='checked_variables'
                                @change="emitVariablesSelected(), Change_Variables(checked_variables),
                                Check_Form(), Change_Mode('manual')"
                                name="inputAirQuality">
                                Material Particulado - Manual
                        </label>
                        <br>
                        <label class='form-check-label-radio'>
                                <input class='form-check-input-radio'
                                type='radio'
                                value='particularMaterialAutomatic'
                                v-model='checked_variables'
                                @change="emitVariablesSelected(), Change_Variables(checked_variables),
                                Check_Form(), Change_Mode('automatic')"
                                name="inputAirQuality">
                                Material Particulado - Automático
                        </label>
                </div>
                <div v-if="!particularMaterial" id= "container-check-all-buttom" class="form-check" style="margin-top:12px">
                        <input
                        class='form-check-input'
                        type='checkbox'
                        @click="checkAll(), Change_Variables(checked_variables),
                        Check_Form(), updateCheckAll(), Change_Mode('automatic') "
                        v-model='isCheckAll'
                        id="selectAll"
                        autocomplete="off">
                        <label class='form-check-label' for='selectAll'>Seleccionar todas las variables</label>
                </div>
           </div>
        </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import dictionary from '../services/variablesDictionary'
export default {
        name: "variables-container",
        props: {
                variables: Array,
                labels: Array,
                particularMaterial: Boolean,
        },
        data() {
                return {
                        checked_variables: [],
                        isCheckAll: false,
                        gasesVariables: Object.keys(dictionary.airGasesVariables)
                };
        },
        computed: {
                ...mapState(['isGases']),
        },
        methods:{
                ...mapActions(['Change_Variables', 'Check_Form', 'Change_Mode']),
                checkAll () {
                        this.isCheckAll = !this.isCheckAll
                        this.checked_variables = []
                        if (this.isCheckAll) {
                                this.checked_variables = [...this.variables];
                        }else{
                                this.checked_variables = [];
                        }
                        this.emitVariablesSelected();
                },
                updateCheckAll () {
                        this.isCheckAll = this.variables.length === this.checked_variables.length
                },

                emitVariablesSelected(){
                        this.$emit('change-variables',this.checked_variables)
                }
        },
}
</script>

<style scoped>
.form-check-input{
    margin-top: 0.9rem;
}
.form-check-label{
   margin-top: 0.75rem;
}
.form-check-input-radio{
        margin-top: 0.2rem;
}
.form-check-label-radio{
        margin-top: 0.85rem;
        font-family: "Ancizar-regular", Helvetica, Arial;
}
.form-group {
  margin-top: 2rem;
}
.form-check-label {
  font-family: "Ancizar-regular", Helvetica, Arial;
}
.col-form-label {
  font-family: "Ancizar-regular", Helvetica, Arial;
}
@media (max-width: 769px) {
  .col-form-label,
  .col-sm-9 {
    width: 100% !important;
  }
}
</style>